module.exports = __webpack_public_path__ + "static/img/topBgc.c2c8811d.png";